/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_BookInputs */

const en_svtag_book = /** @type {(inputs: Svtag_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOOK`)
};

const ar_svtag_book = /** @type {(inputs: Svtag_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#حجز`)
};

const bn_svtag_book = /** @type {(inputs: Svtag_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOOK`)
};

const de_svtag_book = /** @type {(inputs: Svtag_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOOK`)
};

const es_svtag_book = /** @type {(inputs: Svtag_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOOK`)
};

const fr_svtag_book = /** @type {(inputs: Svtag_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOOK`)
};

const pt_svtag_book = /** @type {(inputs: Svtag_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOOK`)
};

const zh_svtag_book = /** @type {(inputs: Svtag_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOOK`)
};

const tr_svtag_book = /** @type {(inputs: Svtag_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOOK`)
};

const ru_svtag_book = /** @type {(inputs: Svtag_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOOK`)
};

const pl_svtag_book = /** @type {(inputs: Svtag_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOOK`)
};

/**
* | output |
* | --- |
* | "#BOOK" |
*
* @param {Svtag_BookInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_book = /** @type {((inputs?: Svtag_BookInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_BookInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_book(inputs)
	if (locale === "bn") return bn_svtag_book(inputs)
	if (locale === "de") return de_svtag_book(inputs)
	if (locale === "es") return es_svtag_book(inputs)
	if (locale === "fr") return fr_svtag_book(inputs)
	if (locale === "pt") return pt_svtag_book(inputs)
	if (locale === "zh") return zh_svtag_book(inputs)
	if (locale === "tr") return tr_svtag_book(inputs)
	if (locale === "ru") return ru_svtag_book(inputs)
	if (locale === "pl") return pl_svtag_book(inputs)
	return en_svtag_book(inputs)
});